export default {
  setMessage(state, message) {
    state.message.text = message.text;
    state.message.messageType = message.messageType || 'success';
  },
};
